import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {SearchButton, SearchForm, SearchInput} from './SearchBox.styled'

export type SearchBoxProps = {
  initialValue: string | null
  onClick: (searchTerm: string) => void
  placeholder?: string
  /** Wider field (fills parent up to max-width); use in toolbars with constrained layout. */
  fillAvailable?: boolean
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  initialValue,
  onClick,
  placeholder,
  fillAvailable,
}) => {
  const {t} = useTranslation<string>()
  const [searchTerm, setSearchTerm] = useState(initialValue || '')

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    onClick(searchTerm)
  }

  return (
    <SearchForm $fillAvailable={fillAvailable} onSubmit={handleSubmit}>
      <SearchInput
        placeholder={placeholder ?? t('Search timeline...')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <SearchButton name="Search" color="secondary" />
    </SearchForm>
  )
}
